import { lazyComponent } from "@redotech/react-util/component";
import { memo } from "react";
import remarkGfm from "remark-gfm";
import * as styles from "./streaming-text.module.css";

const ReactMarkdown = lazyComponent(async () => {
  const { default: ReactMarkdown } = await import("react-markdown");
  return ReactMarkdown;
});

export const StreamingText = memo(function StreamingText({
  content,
  isStreaming,
}: {
  content: string;
  isStreaming: boolean;
}) {
  return (
    <div className={styles.streamingText}>
      <ReactMarkdown
        className={styles.reactMarkdown}
        remarkPlugins={[remarkGfm]}
      >
        {content}
      </ReactMarkdown>
      {isStreaming && <span className={styles.cursor} />}
    </div>
  );
});
